<template>
  <v-menu v-model="menu" :close-on-content-click="false" offset-y transition="scale-transition" :nudge-width="350"
          :disabled="disabled">
    <template v-slot:activator="{ on }">
      <v-btn
        color="indigo"
        dark
        v-on="on"
        small
      >
        <v-icon left>{{ filterIcon }}</v-icon>
        <span v-html="label">{{ label }}</span>

      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        <v-card-subtitle v-html="header"></v-card-subtitle>
        <v-spacer></v-spacer>
        <v-btn icon @click="clearRange">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon left class="pointer" v-on="on">{{ filterRemoveIcon }}</v-icon>
            </template>
            <span>{{ $vuetify.lang.t('$vuetify.map.tableFilter.clear') }}</span>
          </v-tooltip>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>
      <v-card-text>
        <v-range-slider v-model="range" :max="max" :min="min" class="align-center" hide-details color="blue"
                        @change="submit">
          <template v-slot:prepend>
            <v-text-field
              v-model="range[0]"
              @input="submit"
              :rules="[rules.minValue]"
              class="mt-0 pt-0"
              single-line
              dense
              type="number"
              style="width: 70px"

            ></v-text-field>
          </template>
          <template v-slot:append>
            <v-text-field
              v-model="range[1]"
              @input="submit"
              :rules="[rules.maxValue]"
              class="mt-0 pt-0"
              single-line
              dense
              type="number"
              style="width: 70px"
            ></v-text-field>
          </template>
        </v-range-slider>
      </v-card-text>

    </v-card>

  </v-menu>

</template>

<script>
import { mdiFilter, mdiFilterRemove } from '@mdi/js'
import Vuetify from '../../../plugins/vuetify'
import debounce from 'lodash.debounce'

export default {
  name: 'rangeFilter',
  props: {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    column: String,
    header: String,
    disabled: Boolean,
    boundsTracking: {
      type: Boolean,
      default: false
    }
  },
  // In this case, we MUST NOT to use arrow function, because we need access to this.
  // More information at: https://vuejs.org/v2/guide/instance.html#Instance-Lifecycle-Hooks (warning at the end)
  data () {
    return {
      menu: false,
      range: [this.min, this.max],
      rules: {
        minValue: value => value >= this.min || `>= ${this.min}`,
        maxValue: value => value <= this.max || `<= ${this.max}`
      },
      filterIcon: mdiFilter,
      filterRemoveIcon: mdiFilterRemove
    }
  },
  computed: {
    label () {
      const isAllZero = this.range[0] === this.range[1] && this.range[0] === 0
      const isRangeMax = this.range[0] === this.min && this.range[1] === this.max
      if (isAllZero || isRangeMax) {
        return Vuetify.framework.lang.t('$vuetify.map.tableFilter.all')
      } else {
        return `${this.range[0]} ... ${this.range[1]}`
      }
    }
  },
  methods: {
    submit:
      debounce(function () {
        this.$emit('value-changed', { column: this.column, value: this.range, min: this.min, max: this.max })
      }, 250),
    clearRange () {
      // console.log('cleared...')
      this.range = [this.min, this.max]
      this.$emit('value-changed', { column: this.column, value: this.range })
    }
  },
  watch: {
    min (value) {
      value = typeof value === 'string' ? parseInt(value) : value

      // console.log('min', this.column, value, this.range, this.min, this.max)
      this.range = [value, this.range[1]]
      // console.log('min result', this.column, this.range)

      if (this.boundsTracking) {
        // console.log('min value-changed', this.range)
        this.$emit('value-changed', { column: this.column, value: this.range })
      }

      // this.range = [this.range[0] >= value && this.range[0] <= this.max ? this.range[0] : value, this.range[1]]
    },
    max (value) {
      value = typeof value === 'string' ? parseInt(value) : value

      // console.log('max', this.column, value, this.range, this.min, this.max)
      this.range = [this.range[0], value]
      // console.log('max result', this.column, this.range)
      // this.range = [this.range[0], this.range[1] >= this.min && this.range[1] <= value && this.range[1] > 0 ? this.range[1] : value]

      if (this.boundsTracking) {
        // console.log('max value-changed', this.range)
        this.$emit('value-changed', { column: this.column, value: this.range })
      }
    }
  }
}
</script>

<style scoped>

</style>
